/* MrSneaker homepage interactions: hero slideshow + product-row scrollers. */
(function () {
  'use strict';

  function pad(x) { return (x < 10 ? '0' : '') + x; }

  function initHero(root) {
    if (root.dataset.mInit === '1') return; root.dataset.mInit = '1';
    var track = root.querySelector('.mhero__track');
    var slides = root.querySelectorAll('.mhero__slide');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var count = root.querySelector('[data-count]');
    var playpause = root.querySelector('[data-playpause]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.mhero__dot'));
    var n = slides.length;
    if (!track || n === 0) return;
    var i = 0;
    var auto = parseInt(root.dataset.autoplay || '0', 10);
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) auto = 0;
    var playing = auto > 0 && n > 1;
    var timer = null;

    function go(idx) {
      i = (idx + n) % n;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(n);
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); if (playing && auto > 0 && n > 1) timer = setInterval(function () { go(i + 1); }, auto * 1000); }
    function setPlaying(p) {
      playing = p;
      if (playpause) {
        playpause.setAttribute('aria-pressed', p ? 'false' : 'true');
        playpause.setAttribute('aria-label', p ? 'Pause slideshow' : 'Play slideshow');
      }
      if (p) restart(); else stop();
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); restart(); }); });
    if (playpause) {
      if (reduced) { playpause.style.display = 'none'; }
      playpause.addEventListener('click', function () { setPlaying(!playing); });
    }

    go(0); restart();
  }

  function initRow(root) {
    if (root.dataset.mInit === '1') return; root.dataset.mInit = '1';
    var track = root.querySelector('.mrow__track');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track) return;
    function step() { var c = track.querySelector('.mcard'); var w = c ? c.offsetWidth + 16 : 380; return w * 2; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  function boot() {
    document.querySelectorAll('[data-mhero]').forEach(initHero);
    document.querySelectorAll('[data-mrow]').forEach(initRow);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
